import { useContext } from "react";
import { DialogContext } from "./DialogContext.js";
const useDialog = () => {
  const dialog = useContext(DialogContext);
  if (dialog === void 0) {
    throw new Error(`Cannot useDialog outwith DialogProvider.`);
  }
  return dialog;
};
export {
  useDialog
};
//# sourceMappingURL=useDialog.js.map
